export default {
  namespaced: true,
  hikvision_dvr: {
    section: 'hikvision',
    title: "hikvision DVR | hikvision DVR's",
    name: "name",
    ip: "IP",
    masterAccount: "master account",
    tenant: "tenant",
    http_schema: "schema http(s)",
    rtsp_schema: "schema rtsp(s)",
    http_port: "http port",
    rtsp_port: "rtsp port",
    cameras: "cameras",
    syncSuccess: "sync success",
    admin_url: "Link Admin",
    hls_url: "Link HLS",
    websocket_url: "Link Websocket"
  },
};
